import React from 'react';
import { FiXCircle, FiCheckCircle, FiZap, FiTarget, FiSmile } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const ProblemSolution = () => {
  const items = [
    {
      prob: "Pronunciación Imposible",
      probDesc: "12 sonidos vocálicos en inglés vs 5 en español. Los mexicanos solemos batallar con la 'th' y las vocales cortas.",
      sol: "Módulos Interactivos",
      solDesc: "Corrección fonética en tiempo real diseñada para el aparato fonador del hispanohablante.",
      icon: FiZap,
      color: "blue"
    },
    {
      prob: "Miedo a Hablar",
      probDesc: "Vergüenza por el acento o cometer errores en público. Sentimos que 'no nos salen las palabras'.",
      sol: "Salas 'No Judgment'",
      solDesc: "Ambientes seguros de práctica 24/7 con estudiantes de tu nivel para construir confianza inmediata.",
      icon: FiSmile,
      color: "green"
    },
    {
      prob: "Falta de Inmersión",
      probDesc: "Plataformas genéricas diseñadas para el mercado global que no entienden los retos latinos.",
      sol: "Cultura Contrastiva",
      solDesc: "Currículum 100% adaptado que explica el inglés comparándolo con tu español nativo.",
      icon: FiTarget,
      color: "red"
    }
  ];

  return (
    <section className="py-24 px-4 bg-black border-y border-zinc-900 relative">
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/grid-me.png')] opacity-10 pointer-events-none"></div>
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4 uppercase">
            ¿Por Qué <span className="text-red-600">Luchamos</span> con el Inglés?
          </h2>
          <p className="text-gray-400">Y cómo <span className="text-white font-bold">Online Classes English</span> resuelve cada reto con tecnología y empatía.</p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {items.map((item, i) => (
            <div key={i} className="flex flex-col gap-4">
              {/* Problem */}
              <div className="bg-zinc-900/50 border border-red-900/30 p-8 rounded-[2rem] hover:bg-zinc-900 transition-colors">
                <div className="flex items-center gap-2 mb-4 text-red-500 font-black text-xs uppercase tracking-widest">
                  <SafeIcon icon={FiXCircle} /> El Problema
                </div>
                <h4 className="text-white text-xl font-black mb-3 uppercase tracking-tighter italic">{item.prob}</h4>
                <p className="text-gray-400 text-sm leading-relaxed">{item.probDesc}</p>
              </div>

              <div className="flex justify-center py-2">
                <div className="h-10 w-px bg-gradient-to-b from-red-500 to-green-500"></div>
              </div>

              {/* Solution */}
              <div className="bg-zinc-900/50 border border-green-900/30 p-8 rounded-[2rem] hover:bg-zinc-900 transition-colors shadow-2xl shadow-green-900/5">
                <div className="flex items-center gap-2 mb-4 text-green-500 font-black text-xs uppercase tracking-widest">
                  <SafeIcon icon={FiCheckCircle} /> Nuestra Solución
                </div>
                <h4 className="text-white text-xl font-black mb-3 uppercase tracking-tighter italic">{item.sol}</h4>
                <p className="text-gray-400 text-sm leading-relaxed">{item.solDesc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;